<template>
  <div
    class="header"
    :class="{ '-mini': mini, '-fullscreen': expanded, '-light': light }"
  >
    <div class="header__background">
      <div class="header__background-shape"></div>
    </div>
    <div
      class="header__foreground"
      :class="{ '-mini': mini, '-fullscreen': expanded, '-light': light }"
    >
      <div class="header__foreground-content">
        <div class="header__logo">
          <Logo size="30px" :type="logoType" />
        </div>
        <div class="header__title-container">
          <h1 class="header__title" :class="{ '-hidden': expanded || mini }">
            {{ title }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Logo, LogoTypes } from "@/components/Logo";

export default {
  name: "Header",
  components: {
    Logo
  },
  props: {
    title: {
      type: String,
      default: undefined
    },
    mini: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoType: function() {
      if (this.light) {
        return LogoTypes.BLACK;
      }
      return LogoTypes.WHITE;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  $_parent: &;
  align-items: center;
  display: flex;
  height: 70vh;
  max-height: 400px;
  will-change: height;
  position: relative;
  transition: all 1.2s ease-out;

  @include if-tablet {
    height: 500px;
    max-height: 500px;
  }

  @include if-desktop {
    height: 600px;
    max-height: 60vh;
  }

  &__background-shape {
    background: theme-color("gradient");
    border-radius: 50%;
    bottom: 0;
    box-shadow: theme-color("shadow");
    display: block;
    height: 150vh;
    left: 50%;
    min-height: 200px;
    min-width: 600px;
    position: absolute;
    transform: translate(-50%, 0);
    transition: all 1.2s ease;
    width: 200vh;
    will-change: transform;
    z-index: z-index("background");
  }

  &__foreground {
    display: flex;
    justify-content: center;
    width: 100%;
    transition: all 1.2s ease;
    height: 100%;
    padding: spacer("l") * 1.2;

    &.-mini {
      padding: spacer("l");
    }
  }

  &__foreground-content {
    max-width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title-container {
    height: 100%;
    display: flex;
    align-items: center;
  }

  &__title {
    color: theme-color("body");
    font-size: font-size("h1-mobile");
    font-weight: 700;
    line-height: line-height("default");
    text-align: center;
    transition: opacity 0.8s ease;

    @include if-tablet {
      font-size: font-size("h1");
    }

    &.-hidden {
      opacity: 0;
    }
  }

  &.-mini {
    height: sizes("header");

    #{$_parent}__background-shape {
      box-shadow: theme-color("shadow");
    }
  }

  &.-fullscreen {
    height: 100vh;
    max-height: 100vh;

    #{$_parent}__background-shape {
      opacity: 0.85;
      transform: translate(-50%, 0) scale(1.5);
    }
  }

  &.-light {
    #{$_parent}__background-shape {
      background: theme-color("body");
    }
  }
}
</style>
